import React from 'react';
import { loginURL } from '@/httpService/API';
import { inject, observer } from 'mobx-react';
const Privacy = (props) => {
    let { store } = props;
    const tenantId = store?.login.tenantInfo?.id;
    return (
        <div style={{ width: '100%', height: 'calc(100vh - 20px)' }}>
            <iframe style={{ height: '100%', width: '100%' }} src={`${loginURL}privacy_pc?tenant_id=${tenantId}`} frameborder="0"></iframe>
        </div>
    );
};

export default (inject('store')(observer(Privacy)));